/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VocabWordReviewItemDto } from "./VocabWordReviewItemDto";
import type { VocabWordReviewTopicDto } from "./VocabWordReviewTopicDto";
export type VocabWordReviewListDto = {
  language: VocabWordReviewListDto.language;
  /**
   * null = 전체 급수
   */
  jlptLevel: VocabWordReviewListDto.jlptLevel | null;
  total: number;
  /**
   * 카테고리 순서·라벨 (items의 topic 순서와 동일)
   */
  topics: Array<VocabWordReviewTopicDto>;
  /**
   * 카테고리 순 → 급수 순(N5→N1) → 빈도 순
   */
  items: Array<VocabWordReviewItemDto>;
};
export namespace VocabWordReviewListDto {
  export enum language {
    EN = "en",
    JA = "ja",
    KO = "ko",
  }
  /**
   * null = 전체 급수
   */
  export enum jlptLevel {
    N5 = "N5",
    N4 = "N4",
    N3 = "N3",
    N2 = "N2",
    N1 = "N1",
  }
}
